// @vue/component
export default {
  data() {
    return {
      functionOnInterval: undefined,
      intervalAfterFocus: 3000,
      intervalWhileFocused: 5000,
    };
  },
  mounted() {
    window.addEventListener('focus', this.onPageFocus);
    this.setFunctionOnInterval();
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.onPageFocus);
    this.clearFunctionOnInterval();
  },
  methods: {
    clearFunctionOnInterval() {
      if (this.functionOnInterval) {
        clearInterval(this.functionOnInterval);
        this.functionOnInterval = undefined;
      }
    },
    setFunctionOnInterval() {
      this.clearFunctionOnInterval();
      const vm = this;
      this.functionOnInterval = setInterval(() => {
        if (document.hasFocus()) {
          vm.performActionIfFocused();
        } else {
          vm.clearFunctionOnInterval();
        }
      }, this.intervalWhileFocused);
    },
    onPageFocus() {
      this.clearFunctionOnInterval();
      this.performActionIfFocused();
      const vm = this;
      setTimeout(() => {
        vm.performActionIfFocused();
        vm.setFunctionOnInterval();
      }, vm.intervalAfterFocus);
    },
    performActionIfFocused() {
      // To be overridden
    },
  },
};
